import getClient, { buildClient } from './http-common'
import { useAccountQuery } from './queries'

const TOKEN_NAME = 'Auth-_burry_PurpleWave'

const getIsAuthorized = () => {
  const token = JSON.parse(localStorage.getItem('Auth-_burry_PurpleWave'))
  if (token) {
    return token.expires > new Date().toISOString()
  }
  return false
}

// Require authorization for all child components
const RequireAuth = ({
  children,
  unauthorized = null,
}) => {
  useAccountQuery() // TODO : This bad
  if (getIsAuthorized()) return children

  return unauthorized
}

const setToken = (token, client) => {
  const expires = new Date(Date.now() + token.expires_in * 1000).toISOString()

  localStorage.setItem(TOKEN_NAME, JSON.stringify({ expires, ...token }))
  // ? Seperate
  buildClient()
  client.invalidateQueries('bidProfile')
  client.invalidateQueries('person')
  client.refetchQueries('accounts')
}

const login = (username, password, queryClient) => {
  return getClient()
    .post('/login', { username: username, password: password })
    .then(({ data }) => {
      setToken(data, queryClient)
    })
}

const logout = (client) => {
  localStorage.removeItem(TOKEN_NAME)
  getClient().post('/logout')

  // Proxy Check
  if (localStorage.getItem('proxyLogin')) {
    localStorage.removeItem('proxyLogin')
    document.querySelector('body').classList.remove('proxy-bg')
  }
  client.refetchQueries('accounts')
  window.PurpleWave?.vent.trigger('logout')
}

export { RequireAuth, getIsAuthorized, setToken, login, logout }

